<template>
  <div class="search-bar">
    <div class="search-box">
      <van-icon class="search-icon iconfont" class-prefix="icon" name="sousuo" @click="searchHandle"></van-icon>
<!--      <form action="javascript:void(0)"><input type="search" v-model="keyword" placeholder="请输入关键字" @change="searchHandle"/></form>-->
      <form action="javascript:void(0)"><input type="search" v-model="keyword" placeholder="请输入关键字" @search="searchHandle"/></form>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchBar",
  data() {
    return {
      keyword: '',
    }
  },
  methods: {
    searchHandle() {
      this.$emit('searchHandle', this.keyword)
    }
  },
  watch: {
    // keyword: {
    //   handler: function (val, oldval) {
    //     this.searchHandle()
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/theme/theme.scss';
.search-bar {
  width: 100%;
  height: 44px;
  padding: 8px 15px;
  box-sizing: border-box;
  display: -webkit-flex;/* Safari */
  display: flex;
  background: #fff;
  color: $c333;
  .search-box {
    height: 28px;
    line-height: 28px;
    padding: 0 35px 0 15px;
    background: #F7F7F7;
    border: 1px solid #FFFFFF;
    border-radius: 14px;
    flex: 1;
    position: relative;
    @extend .font13;
    .search-icon{
      position: absolute;
      top:0;
      right: 15px;
    }
    form{
      width: 100%;
      background: transparent;
      height: 28px;
      line-height: 28px;
      padding: 0;
      input {
        float: left;
        width: 100%;
        height: 28px;
        line-height: 28px;
        background: transparent;
        @extend .font13;
        &::-webkit-search-cancel-button{
          -webkit-appearance: none;
        }
      }
    }
  }
}
</style>
